
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.14 20.14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","stroke":"#000","stroke-miterlimit":"10","d":"M2.94 2.98h14.18v10.17H2.94z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M18.12 0H2a2 2 0 00-2 2v18.14l4-4h14.12a2 2 0 002-2V2a2 2 0 00-2-2zm-2 12.08l-4-3.22v3.22H4V4h8.05v3.25l4-3.22z"}})])
          )
        }
      }
    